export default "__VITE_ASSET__BzTwH9D3__"